module.exports = __webpack_public_path__ + "static/img/daying.e6f4720b.png";